export const CUSTOM_TABLE_NEWS_LIMIT = 30;
